import { useTranslation } from 'react-i18next';
import useAddJourneySchema from './AddJourneyModal.schema';
import { EmailReminderType, Market, ReminderChannel } from 'generated/event.types';

const timingTypeOptions = [
  { id: EmailReminderType.before_start, label: 'Before Start' },
  { id: EmailReminderType.after_end, label: 'After End' },
];

const marketOptions = Object.values(Market).map((market) => ({
  id: market,
  label: market.toUpperCase(),
}));

const channelOptions = [
  { id: ReminderChannel.email, label: 'Email' },
  { id: ReminderChannel.sms, label: 'SMS' },
  { id: ReminderChannel.whatsapp, label: 'WhatsApp' },
];

const useAddJourneyConfig = () => {
  const { t } = useTranslation();
  const schema = useAddJourneySchema();

  const addJourneyConfig = {
    name: {
      name: 'name',
      label: t('manage_journeys_name_label'),
      placeholder: t('manage_journeys_name_placeholder'),
      required: true,
      defaultValue: '',
      validation: schema.name,
    },
    sfmcJourneyApiKey: {
      name: 'sfmcJourneyApiKey',
      label: t('manage_journeys_sfmc_key_label'),
      placeholder: t('manage_journeys_sfmc_key_placeholder'),
      required: false,
      defaultValue: '',
      validation: schema.sfmcJourneyApiKey,
    },
    format: {
      name: 'format',
      label: t('manage_journeys_timing_type_label'),
      placeholder: t('manage_journeys_timing_type_placeholder'),
      required: true,
      options: timingTypeOptions,
      defaultValue: EmailReminderType.before_start,
      validation: schema.format,
    },
    timeInHour: {
      name: 'timeInHour',
      label: t('manage_journeys_offset_hours_label'),
      placeholder: t('manage_journeys_offset_hours_placeholder'),
      required: true,
      defaultValue: '',
      validation: schema.timeInHour,
    },
    marketDefaults: {
      name: 'marketDefaults',
      label: t('manage_journeys_market_defaults_label'),
      placeholder: t('manage_journeys_market_defaults_placeholder'),
      required: true,
      options: marketOptions,
      defaultValue: [],
      validation: schema.marketDefaults,
    },
    reminderType: {
      name: 'reminderType',
      label: t('manage_journeys_reminder_type_label'),
      placeholder: t('manage_journeys_reminder_type_placeholder'),
      required: false,
      defaultValue: '',
      validation: schema.reminderType,
    },
    channel: {
      name: 'channel',
      label: t('manage_journeys_channel_label'),
      placeholder: t('manage_journeys_channel_placeholder'),
      required: true,
      options: channelOptions,
      defaultValue: ReminderChannel.email,
      validation: schema.channel,
    },
  };

  return { addJourneyConfig };
};

export default useAddJourneyConfig;
